//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";

export default {
    components: {
        AQAvatar
    },
    props: {},
    data() {
        return {
            pictureUploadedByUser: null,
            size: 36,
            photoList: [
                "supervisor",
                "applicationImage",
                "platform",
                "external",
                "applicationSpecific",
                "system",
                "platformApplicationDisabled",
                "externalDisabled"
            ],
            typeList: [
                "systemInternalUser",
                "systemExternalUser",
                "userPlatform",
                "platformManager",
                "externalUser",
                "platformSetManager",
                "externallySetManager",
                "app",
                "appUnpublished",
                "appPublished",
                "publishedNewChanges",
                "system",
                "platform",
                "applicationSpecific",
                "externalGroup"
            ],
            photo: null,
            type: "userPlatform",
            disabled: false,
            roundedOption: true,
            notification: false,
            hover: false,
            sizeUpdate: 36
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        uploadPicture(event) {
            this.pictureUploadedByUser = event;
        },
        showNotification(photo) {
            this.type = photo;
        },
        typeSelect(type) {
            this.type = type;
        }
    }
};
